import {
  addNinjaDialogClose,
  addNinjaDialogForm,
  addNinjaDialogOpen,
  ninjaFormUpdate,
} from './action-creators';

import { addNinja, updateNinja } from '../actions/actions';
import { fetchCoders } from '../../../actions/coders-actions';

export const dialogClose = () =>
  dispatch =>
    dispatch(addNinjaDialogClose());

export const dialogForm = obj =>
  dispatch =>
    dispatch(addNinjaDialogForm(obj));

export const dialogOpen = () =>
  dispatch =>
    dispatch(addNinjaDialogOpen());

export const updateNinjaForm = form =>
  dispatch =>
    dispatch(ninjaFormUpdate(form));

export const addOrUpdateNinja = () =>
  (dispatch, getState) => {
    const {
      coders,
      ui,
    } = getState();

    const {
      coderAttendance,
      coderBadges,
      firstName,
      id,
      lastName,
      title,
    } = ui.updateNinjas.ninjaDialog.form;

    if (id) { // update Ninja
      const updatedNinja = {
        attendance: {
          ...coderAttendance,
        },
        badges: coderBadges,
        firstName,
        key: id,
        lastName,
        title,
      };
      dispatch(dialogClose())
        .then(updateNinja(updatedNinja))
        .then(fetchCoders());
    } else { // add Ninja
      const todaysDate = new Date().toString();
      const modifiedId = !id && coders.length + 1;
      const ninja = {
        attendance: {
          0: todaysDate,
        },
        badges: coderBadges,
        firstName,
        key: modifiedId,
        lastName,
        title,
      };
      dispatch(dialogClose())
        .then(addNinja(ninja))
        .then(fetchCoders());
    }
  };




/** WEBPACK FOOTER **
 ** ./src/state/ui/update-ninjas/add-ninja-dialog/actions.js
 **/